import {
  GET_DASHBOARD_SKILL_ASSESSMENT_TREND,

  GET_DASHBOARD_SKILL_ASSESSMENT_STATUS,
  GET_DASHBOARD_COMPETENCY_FRAMEWORK_STATUS,
  GET_DASHBOARD_RESPONSE_STATUS,

  GET_DASHBOARD_TOTAL_ASSESSMENT,
  GET_DASHBOARD_EXPIRED_ASSESSMENTS,
  GET_DASHBOARD_UPCOMING_ASSESSMENTS,
  GET_DASHBOARD_PUBLISHED_ASSESSMENTS,

  GET_ASSESSMENT_STATUS_DETAILS,
  GET_DASHBOARD_COMPETENCY_FRAMEWORK_DETAILS,
  GET_RESPONSE_STATUS_DETAILS,
  GET_SKILL_ASSESSMENT_TREND_DETAILS
} from "@routes";

import { createApiSlice } from "@common/common-slice/commonSlice";

const apiConfig = [
  {
    name: "getAssessmentTrendByProj",
    method: "get",
    url: GET_DASHBOARD_SKILL_ASSESSMENT_TREND,
    stateKey: "assessmentTrendData",
  },

//   STATUS 
  {
    name: "getDashboardSkillAssessmentStatus",
    method: "get",
    url: GET_DASHBOARD_SKILL_ASSESSMENT_STATUS,
    stateKey: "dashboardSkillAssessmentStatusData",
  },
  {
    name: "getDashboardCompetencyFrameworkStatus",
    method: "get",
    url: GET_DASHBOARD_COMPETENCY_FRAMEWORK_STATUS,
    stateKey: "dashboardCompetencyFrameworkStatusData",
  },
  {
    name: "getDashboardResponseStatus",
    method: "get",
    url: GET_DASHBOARD_RESPONSE_STATUS,
    stateKey: "dashboardResponseStatusData",
  },
// ASSESSMENTS
  {
    name: "getDashboardRecentAssessments",
    method: "get",
    url: GET_DASHBOARD_PUBLISHED_ASSESSMENTS,
    stateKey: "recentAssessmentsData",
  },
  {
    name: "getDashboardUpcomingDeadlines",
    method: "get",
    url: GET_DASHBOARD_UPCOMING_ASSESSMENTS,
    stateKey: "upcomingDeadlinesData",
  },

  // five cards total assessments
  {
    name: "getDashboardTotalAssessments",
    method: "get",
    url: GET_DASHBOARD_TOTAL_ASSESSMENT,
    stateKey: "dashboardTotalAssessmentsData",
  },
  {
    name: "getDashboardExpiredAssessments",
    method: "get",
    url: GET_DASHBOARD_EXPIRED_ASSESSMENTS,
    stateKey: "dashboardExpiredAssessmentsData",
  },

  // DETAILS
  {
    name: "getAssessmentStatusDetail",
    method: "get",
    url: GET_ASSESSMENT_STATUS_DETAILS,
    stateKey: "dashboardStatusDetails",
  },
  {
    name: "getCompetencyFrameworkStatusDetail",
    method: "get",
    url: GET_DASHBOARD_COMPETENCY_FRAMEWORK_DETAILS,
    stateKey: "dashboardStatusDetails",
  },
  {
    name: "getResponseStatusDetail",
    method: "get",
    url: GET_RESPONSE_STATUS_DETAILS,
    stateKey: "dashboardStatusDetails",
  },
  {
    name: "getSkillAssessmentTrendDetail",
    method: "get",
    url: GET_SKILL_ASSESSMENT_TREND_DETAILS,
    stateKey: "dashboardSkillAssessmentTrendDetailData",
  },
];

// Define custom reducers and their initial state
const customReducers = {
  initialState: {
    completionRateData: [],
    participationRateData: [],
    assessmentStatusCountData: [],
    dashboardSkillAssessmentStatusData: [],
    dashboardCompetencyFrameworkStatusData: [],
    dashboardResponseStatusData: [],
    recentAssessmentsData: [],
    upcomingDeadlinesData: [],
    dashboardTotalAssessmentsData: [],
    dashboardActiveAssessmentsData: [],
    dashboardPublishedAssessmentsData: [],
    dashboardCompletedAssessmentsData: [],
    dashboardExpiredAssessmentsData: [],
    startDate: null,
    endDate: null,
    selectedUser: null,
    assessmentTrendData: [],
    dashboardStatusDetails: [],
    dashboardSkillAssessmentTrendDetailData: []
  },
  reducers: {
    setStartDate(state, action) {
      state.startDate = action.payload;
    },
    setEndDate(state, action) {
      state.endDate = action.payload;
    },
    setSelectedUser(state, action) {
      state.selectedUser = action.payload;
    },
  },
  extraReducers: {},
};

// Generate the slice, thunks, and actions using the utility function
const { slice, thunks, actions } = createApiSlice("talenaiseDashboard", apiConfig, customReducers);

const talenaiseDashboardSlice = slice;
// Export the slice's reducer
export default talenaiseDashboardSlice.reducer;

// Destructure and export thunks directly from thunksExports
export const { 
  getAssessmentTrendByProj,
  getDashboardSkillAssessmentStatus,
  getDashboardCompetencyFrameworkStatus,
  getDashboardResponseStatus,
  getDashboardRecentAssessments,
  getDashboardUpcomingDeadlines,
  getDashboardTotalAssessments,
  getDashboardExpiredAssessments,

  getAssessmentStatusDetail,
  getCompetencyFrameworkStatusDetail,
  getResponseStatusDetail,
  getSkillAssessmentTrendDetail
 } = thunks;

export const { setStartDate, setEndDate, setSelectedUser } = actions;
